import { Component, inject, OnInit } from "@angular/core";
import { DialogRef, ForgeScaffoldModule, ForgeTextFieldModule, ForgeToolbarModule } from "@tylertech/forge-angular";
import { Command, CommandBarComponent, LabelCommand } from "@tylertech/commands-module";
import { FormsModule } from "@angular/forms";
import { Utilities } from "@tylertech/shared-module";

@Component({
    selector: "save-dialog",
    templateUrl: "./saveDialog.tmpl.html",
    imports: [
        CommandBarComponent,
        ForgeScaffoldModule,
        ForgeTextFieldModule,
        ForgeToolbarModule,
        FormsModule
    ]
})

export class SaveDialogComponent implements OnInit
{
    private _dialogRef = inject(DialogRef);
    newLoadQuery: string;
    commands: Command[];

    ngOnInit(): void
    {
        const self = this;
        this.commands = [
            new LabelCommand({
                label: "Cancel",
                action: () => self.close(),
            }),
            new LabelCommand({
                label: "Save",
                action: () => self.close(true)
            }),
        ];
    }

    onKeyDown(event: KeyboardEvent): void
    {
        if (event.key === "Enter" || event.key === "NumPadEnter")
        {
            event.preventDefault();
            this.close(true);
        }
    }

    close(save = false): void
    {
        if (save && Utilities.IsNullOrUndefinedOrEmpty(this.newLoadQuery?.trim()))
            return;
        this._dialogRef.close(save ? this.newLoadQuery : null);
    }
}
